"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Box_1 = __importDefault(require("@mui/material/Box"));
var system_1 = require("@mui/system");
var general_1 = require("utils/general");
// TODO: replace styles on TableRow when all use the tableConf format
exports.default = (0, system_1.styled)(Box_1.default, { shouldForwardProp: (0, general_1.omitProps)('isHidden', 'strikethrough') })(function (_a) {
    var _b;
    var _c;
    var theme = _a.theme, isHidden = _a.isHidden, strikethrough = _a.strikethrough;
    return (__assign(__assign((_b = {}, _b[theme.breakpoints.down('sm')] = {
        display: 'flex',
        alignItems: 'stretch',
    }, _b[theme.breakpoints.up('sm')] = { display: 'inline-flex' }, _b['&:hover .SortableArrows'] = { opacity: 1 }, _b), (isHidden && {
        textDecoration: 'line-through',
        div: {
            textDecoration: 'line-through',
        },
    })), strikethrough && {
        textDecoration: 'line-through',
        ' .svg-inline--fa': { color: (_c = theme.palette.neutral) === null || _c === void 0 ? void 0 : _c.main },
    }));
});
